export enum RuntimeEnvKey {
  ApiUrlOverride = "REACT_APP_API_URL_OVERRIDE",
  AuthConfig = "REACT_APP_AUTH_CONFIG",
  ShareUrl = "REACT_APP_SHARE_URL",
}

declare global {
  interface Window {
    REACT_APP_API_URL_OVERRIDE?: string;
    REACT_APP_AUTH_CONFIG?: string;
    REACT_APP_SHARE_URL?: string;
  }
}

export const getBuildTimeEnv = (key: RuntimeEnvKey): string | undefined => {
  switch (key) {
    case RuntimeEnvKey.ApiUrlOverride:
      return import.meta.env.REACT_APP_API_URL_OVERRIDE;
    case RuntimeEnvKey.AuthConfig:
      return import.meta.env.REACT_APP_AUTH_CONFIG;
    case RuntimeEnvKey.ShareUrl:
      return import.meta.env.REACT_APP_SHARE_URL;
    default:
      return undefined;
  }
};

export const getWindowEnv = (key: RuntimeEnvKey): string | undefined => {
  if (typeof window !== "undefined") {
    return window[key];
  }

  return undefined;
};

export const getRuntimeEnv = (key: RuntimeEnvKey): string | undefined =>
  getWindowEnv(key) || getBuildTimeEnv(key);

export const getApiUrlOverride = (): string | undefined =>
  getRuntimeEnv(RuntimeEnvKey.ApiUrlOverride);

export const getShareUrlOverride = (): string | undefined => getRuntimeEnv(RuntimeEnvKey.ShareUrl);
